const Play = () => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1080 1080">
    <circle fill="#FFFFFF" cx="539.5" cy="539.5" r="262.5"/>
    <polygon fill="#231F20" points="458.5,541.4 458.4,424.2 560,482.7 661.5,541.1 560.1,599.9 458.7,658.6 "/>
  </svg>
);
export default Play;
